<template>
    <div>
        <transition-group name="fade" mode="out-in" tag="div" class="posts__section posts__section--request" v-show="!isFetching">

            <div v-cloak :key="product.id" class="post__content" v-for="(product, index) in products" v-show="!isFetching">

                <div class="product-item-container">

                <a v-if="product.images">
                    <slick
                            class="post__content-thumbnail"
                            ref="slick"
                            :options="{ arrows: true, dots: true, infinite: false }"
                    >
                        <div v-for="image in product.images" class="slider-inner" ><img :src="'https://amsterdamlightfestival.com/storage/' + image" alt=""></div>
                    </slick><!-- /.post__content-thumbnail -->
                </a>

                <div class="post__content-inner">
                    <div class="content-stretch">
                      <h2>{{product.title}}</h2>

                      <div class="product-content" v-html="product.content"></div>
                    </div>
                    <div class="characteristics">
                        <div class="characteristic" v-for="(characteristic, index) in product.characteristics" x-data="{hover: false}" x-on:mouseover="hover = true" x-on:mouseleave="hover = false" x-bind:class="(hover) ? 'charcteristic--explicit' : ''">
                            <img class="characteristic-icon" :src="'/site/img/characteristic-' + characteristic.type + '.svg'" alt="" />
                            <span class="characteristic-text"><span>{{ characteristic.name }}</span></span>
                        </div>
                    </div>

                    <div class="post__content-action">
                        <span v-show="product.highlighted">{{highlighted}}</span>
                        <a :href="'/product/' + product.id + '?locale=' + helpers.getLocale()" :data-href="product.cta_url" :target="product.external_link ? '_blank' : '_self'" class="post__content-btn" rel="noopener noreferrer" @click="registerGoogleClick(product)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.3"><path d="M14 7.2L6.9 0l-.6.6 6 6.1H0v.9h12.3l-6 6.1.6.6z"></path></svg>
                        </a>
                    </div><!-- /.action-section -->
                </div>
                </div>

            </div><!-- /.posts__section -->

        </transition-group>



        <transition name="fade" mode="out-in">
            <alf-loader v-show="isFetching"></alf-loader>
        </transition>

    </div>
</template>

<!--TODO: hier zitten veel dingen in die gecheckt moeten worden-->
<script>
    import Loader from '.././loader'
    import helpers from '../../helpers';
    import Slick from 'vue-slick'
    export default{
        components: {
            Slick,
            'alf-loader': Loader
        },
        props: {
            'products': {required: true},
            'isFetching': {required: true},
            'specialFilterSlug': {required: true}
        },
        data: function(){
            return {
                helpers: helpers,
                hover: false
            }
        },
        methods: {
            reInit: function() {
                // Helpful if you have to deal with v-for to update dynamic lists
                this.$nextTick(() => {

                    let sliders = this.$refs.slick;
                    for(let i = 0; i < sliders.length; i++){
                        sliders[i].reSlick();
                    }
                });
            },
            registerGoogleClick: function(product){
                ga('send', 'pageview', '/outbound/' + helpers.getLocale() + '/' + product.product_category_title + '/' + helpers.slugify(product.title) + '/' + product.id);
            }
        },
        computed: {
            highlighted: function() {
                if(helpers.getLocale() === 'nl') {
                    return 'UITGELICHT';
                }
                return 'FEATURED';
            }
        }
    }

    var characteristics = document.querySelectorAll(".characteristic");
    characteristics.forEach(toggleClassOnHover);

    function toggleClassOnHover(event) {
        console.log(event);
        // e.addEventListener("hover", function() {
        //
        // })
    }
</script>

<style lang="scss">

    .characteristics {
        z-index: 1;
    }

    .characteristics:after {
        content: "";
        clear: both;
        display: block;
    }

    .characteristic {
        position: relative;
        height: 30px;
        display: inline-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 15px;
        cursor: pointer;
        z-index: 0;
        transition: z-index 0.3s cubic-bezier(1, 0, 1, 0);
    }

    .characteristic:nth-child(4) {
        justify-content: flex-end;
    }
    .characteristic:nth-child(5) {
        justify-content: flex-end;
    }

    .characteristic:hover {
        cursor: pointer;
        z-index: 3;
        transition: z-index 0s cubic-bezier(1, 0, 1, 0);
    }

    .characteristic:hover ~ .characteristic {
        z-index: 2;
    }

    .charcteristic--explicit {
        z-index: 4 !important;
        transition: z-index 0s cubic-bezier(1, 0, 1, 0) !important;
    }

    .characteristic-icon {
        position: relative;
        height: 30px;
        margin-top: -1px;
        margin-right: 8px;
        z-index: 1;
    }

    .characteristic:last-child .characteristic-icon {
        margin-right: 0;
    }

    .characteristic-text {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        max-width: 30px;
        margin-left: auto;
        border-radius: 30px;
        background-color: white;
        border: 1px solid black;
        overflow: hidden;
        z-index: 0;
        transition: max-width 0.4s cubic-bezier(.42,.38,0,1);
    }

    .characteristic:nth-child(4) .characteristic-text {
        left: auto;
        right: 0;
    }

    .characteristic:nth-child(4) .characteristic-icon {
        margin-right:0;
    }

    .characteristic:nth-child(5) .characteristic-text {
        left: auto;
        right: 0;
    }

    .characteristic:nth-child(5) .characteristic-icon {
        margin-left:8px;
    }

    .characteristic-text > span {
        min-width: 105px;
        opacity: 0;
        padding: 0 12px 0 30px;
        text-align: center;
        transition: opacity 0.3s linear;
    }

    .characteristic:nth-child(4) .characteristic-text > span {
        padding: 0 30px 0 12px;
    }
    .characteristic:nth-child(5) .characteristic-text > span {
        padding: 0 30px 0 12px;
    }

    .characteristic:hover .characteristic-text {
        max-width: 300px;
        opacity: 1;
        transition: max-width 1.1s cubic-bezier(.42,.38,0,1);
    }

    .characteristic:hover .characteristic-text > span {
        opacity: 1;
        transition: opacity 0.3s linear 0.1s;
    }

    .bookatour .page_content{
        padding-top: 25px;
        padding-bottom: 0;
    }

    .product-item-container{
        position: relative;
    }


    .product-content{
        margin-bottom: 10px;
    }

    .post__content{
        position: relative;
        width: 33.3%;
    }

    .post__content-action:before {
        width: 130px;
    }

    @media only screen and (min-width: 994px) and (max-width: 1200px) {

        .post__content {
            .product-content {
                min-height: 0;
            }

            .post__content-inner {
                .product-content {
                    h2 {
                        font-size: 22px;
                        line-height: 1.2em;
                        margin-bottom: 10px;
                    }
                }

            }
        }
    }

    @media only screen and (max-width: 600px){
        .post__content {
            width: 100%;
        }
    }

    /*.post__content-inner{*/
        /*min-height:150px;*/
    /*}*/

    .slider-inner img{
        max-width: 325px;
        max-height:225px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
    .fade-enter-active {
        @for $i from 1 through 30 {
            &:nth-of-type(#{$i}) {
                transition-delay: $i * 0.06s;
            }
        }
    }
    [v-cloak] {display: none}


    .post__content-inner h2{
        line-height: 1.2;
        margin-bottom: 5px;
    }

    @media screen and(max-width: 375px){
        .post__content{
            padding-left: 0 !important;
            padding-right: 0 !important;
        }

    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/temporary-bhf-filter/bhf-filter-listing.vue